






import {traineesClient} from "@/api/clients.context";
import {TraineeProfileModel} from "@/domain/trainees/TraineeProfileModel";

import {Component, Vue} from 'vue-property-decorator';

@Component({})

export default class traineeProfile extends Vue {
    private id:string='';
    private profile :TraineeProfileModel|null =null;

    async mounted() {
        this.id = this.$route.params.id;

        //this.profile = await traineeService.GetProfile(this.id);
    }

}
